import { isComboPromo } from './promotionTypes.js'

/**
 * @description 将 TDC promotionType=5 的订单行转换为通用商品表格所需的组合促销栏元数据。
 * promotionType=4 是搭配套餐，不生成组合促销栏。
 * @param {Record<string, unknown>|null|undefined} row
 * @returns {{ promoPackageGroupKey: string, promoPackageName: string }|null}
 */
export function resolveOrderComboPromotionPackageDisplay(row) {
  if (!isComboPromo(row?.promotionType)) return null

  const promoPackageGroupKey = String(row?.comboGroupKey || '').trim()
  const promoPackageName = String(row?.promotionName || '').trim()
  if (!promoPackageGroupKey || !promoPackageName) return null

  return { promoPackageGroupKey, promoPackageName }
}

/**
 * @description 为订单确认/详情商品行补齐组合促销栏元数据，不插入业务商品行。
 * @param {Array<Record<string, unknown>>} rows
 * @returns {Array<Record<string, unknown>>}
 */
export function applyOrderComboPromotionPackageDisplay(rows) {
  return (Array.isArray(rows) ? rows : []).map((row) => {
    const display = resolveOrderComboPromotionPackageDisplay(row)
    return display ? { ...row, ...display } : row
  })
}
